/*
 * @Description: c处方
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-06 18:29:08
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-11 16:35:12
 */
import request from '../../utils/request'
import server from './config'

export default {
    /**
     * 处方详情
     */
    detail: (data) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/prescriptionInfo`,
            method: 'post',
            data
        })
    },
    /**
     * 我的处方
     */
    prescriptionPage: (data) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/prescriptionPage`,
            method: 'post',
            data
        })
    },
    /**
     * 处方详情
     */
    prescriptionInfo: (data) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/prescriptionInfo`,
            method: 'post',
            data
        })
    },
    /**
     * 根据恩必普数量查询关联的服务包服务内容
     */
    getManagerTemplateInfo: (data) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/getManagerTemplateInfo`,
            method: 'post',
            data
        })
    },
    /**
     * 根据恩必普、欧来宁数量查询关联的服务包服务内容
     */
    getManagerTemplateInfoList: (data) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/getManagerTemplateInfoList`,
            method: 'post',
            data
        })
    },
    // 药品订单分页
    drugOrderPage (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/drugOrderPage`,
            method: 'post',
            data
        })
    },
    // 药品订单详情
    drugOrderInfo (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/drugOrderInfo`,
            method: 'post',
            data
        })
    },
    // 药品订单详情
    getOrderPrescriptionOtcDetailById (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/getOrderPrescriptionOtcDetailById`,
            method: 'post',
            data
        })
    },
    // 取消药品订单
    cancelOrder (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/cancelOrder`,
            method: 'post',
            data
        })
    },
    // 确认收获药品订单
    goodsConfirmReceipt (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/goodsConfirmReceipt`,
            method: 'post',
            data
        })
    },
    // 药品详情
    drugInfo (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/drugInfo`,
            method: 'post',
            data
        })
    },
    // 下单
    createOrder (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/createOrder`,
            method: 'post',
            data
        })
    },
    // 重新下单
    payAgain (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/payAgain`,
            method: 'post',
            data
        })
    },
    // 子订单下单
    subOrderCreateOrder (data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/subOrderCreateOrder`,
            method: 'post',
            data
        })
    },
    //获取发票详情
    getInnvoiceDetail(data){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/invoiceRecord/1/invoice/invoiceRecord/getOrderRecordList`,
            method: 'post',
            data
        })
    },
    //更改发票信息
    changeInnvoice(data){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/invoiceRecord/1/invoice/invoiceRecord/applyInvoiceRecord`,
            method: 'post',
            data
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/modules/pharmacy.js